import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-warning',
  templateUrl: './fh-svg-warning.component.html',
  styleUrl: './fh-svg-warning.component.scss'
})
export class FhSvgWarningComponent {
  @Input() color: string = '';
}
